<div class="container-fluid">
  <div class="d-flex align-items-center">
    <app-gene-table-selector [showGenomic]="false" [showAssembly]="false" [showRepseq]="false" [showCommon]="true"></app-gene-table-selector>

    <!-- Data presence indicators -->
    <div class="d-flex gap-2 ms-3">
      <span class="badge"
           [class.bg-success]="genomic_present"
           [class.bg-secondary]="!genomic_present"
           [class.text-white]="true">
        🧬 Genomic Data
        <span class="ms-1">
          {{genomic_present ? '✓' : '✗'}}
        </span>
      </span>

      <span class="badge"
           [class.bg-success]="airrseq_present"
           [class.bg-secondary]="!airrseq_present"
           [class.text-white]="true">
        📊 AIRR-seq Data
        <span class="ms-1">
          {{airrseq_present ? '✓' : '✗'}}
        </span>
      </span>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-auto">
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text" for="selectAsc">ASC</label>
        </div>
        <select class="custom-select" id="selectAsc" [(ngModel)]="selection.asc" [disabled]="ascDisabled" (ngModelChange)="onAscChange()">
          @if (ascLoading) {
            <option value="">Loading...</option>
          } @else {
            <option value="">Select ASC</option>
            @for (asc of availableAscs; track asc) {
              <option [value]="asc">{{asc}}</option>
            }
          }
        </select>
        @if (ascLoading) {
          <div class="input-group-append">
            <span class="input-group-text">
              <div class="spinner-border spinner-border-sm" role="status"></div>
            </span>
          </div>
        }
      </div>
      @if (ascError) {
        <small class="text-danger">Error loading ASCs: {{ascError}}</small>
      }
    </div>
  </div>

  <mat-tab-group animationDuration="0ms" mat-stretch-tabs (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Overview">
      <ng-template matTabContent>
        <app-gene-refbook-overview [selection]="selection"></app-gene-refbook-overview>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

</div>
